<script setup>
import {onMounted} from "vue";
import {useUserTreatmentSessionStore} from "@/stores/userTreatmentSession.store";
import {storeToRefs} from "pinia";
import convertDateToString from "@/helpers/utils";
import {useGlobalStore} from "@/stores/global.store";


const globalStore = useGlobalStore();
const userTreatmentSessionStore = useUserTreatmentSessionStore();
const {userTreatmentSessionStatistics, userTreatmentSessions, overdueUserTreatmentSessions} = storeToRefs(userTreatmentSessionStore);

const getCurrentMonthDates = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    return { firstDay, lastDay };
};

const handleSelectData = async (date) => {
    globalStore.loading = true;
    await userTreatmentSessionStore.fetchAll(convertDateToString(date), convertDateToString(date));
    globalStore.loading = false;
}

const formatDay = (day) => {
    const dataEntry = userTreatmentSessionStatistics.value.find(
        (data) => data.schedule_date === convertDateToString(day.date)
    );

    if (dataEntry) {
        day.bottomInfo = dataEntry.total_count + '(' + dataEntry.completed_count + ')';
        day.className = 'calendar-green-cell';
    }

    return day;
}

const { firstDay, lastDay } = getCurrentMonthDates();
const {active} = true;

onMounted(async () => {
    await userTreatmentSessionStore.fetchStatistics(convertDateToString(firstDay), convertDateToString(lastDay));
    await handleSelectData(new Date());
    await userTreatmentSessionStore.fetchOverdue()
})

</script>

<template>
  <van-space direction="vertical" fill>
      <van-calendar
          :show-title="false"
          :poppable="false"
          :show-confirm="false"
          :min-date= firstDay
          :max-date= lastDay
          :formatter="formatDay"
          @select="handleSelectData"
      />
      <van-tabs v-model:active="active">
          <van-tab :title="'Scheduled (' + userTreatmentSessions.length + ')'" name="scheduled">
              <div v-if="userTreatmentSessions.length === 0">
                  <van-empty image="search" description="Nothing found"/>
              </div>
              <div v-if="userTreatmentSessions.length > 0">
                  <van-cell-group inset
                                  v-for="userTreatmentSession in userTreatmentSessions" :key="userTreatmentSession.id">
                      <van-cell is-link :to="'/session/' + userTreatmentSession.id" title="Session"
                                :value="userTreatmentSession.treatment_session.name"/>
                      <van-cell title="Status" title-class="" :value="userTreatmentSession.status"/>
                      <van-cell title="Scheduled" :value="userTreatmentSession.schedule_at_formatted"/>
                      <van-cell title="Created" :value="userTreatmentSession.created_at_formatted"/>
                      <van-cell title="Counselor" v-if="userTreatmentSession.staff_user">
                          <template #label>
                              {{ userTreatmentSession.staff_user }}
                          </template>
                      </van-cell>
                      <van-row>&nbsp;</van-row>
                  </van-cell-group>
              </div>
          </van-tab>
          <van-tab :title="'Overdue (' + overdueUserTreatmentSessions.length + ')'" name="overdue">
              <div v-if="overdueUserTreatmentSessions.length === 0">
                  <van-empty image="search" description="Nothing found"/>
              </div>
              <div v-if="overdueUserTreatmentSessions.length > 0">
                  <van-cell-group inset
                                  v-for="userTreatmentSession in overdueUserTreatmentSessions" :key="userTreatmentSession.id">
                      <van-cell is-link :to="'/session/' + userTreatmentSession.id" title="Session"
                                :value="userTreatmentSession.treatment_session.name"/>
                      <van-cell title="Status" title-class="" :value="userTreatmentSession.status"/>
                      <van-cell title="Scheduled" :value="userTreatmentSession.schedule_at_formatted"/>
                      <van-cell title="Created" :value="userTreatmentSession.created_at_formatted"/>
                      <van-cell title="Counselor" v-if="userTreatmentSession.staff_user">
                          <template #label>
                              {{ userTreatmentSession.staff_user }}
                          </template>
                      </van-cell>
                      <van-row>&nbsp;</van-row>
                  </van-cell-group>
              </div>
          </van-tab>
      </van-tabs>
  </van-space>
</template>
